(function () {
  function parseTime(str) {
    if (!str) return null;
    var parts = String(str).trim().split(':');
    if (parts.length < 2) return null;
    var h = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    if (isNaN(h) || isNaN(m)) return null;
    return h * 60 + m;
  }

  function getNowInTimezone(tz) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      weekday: 'short',
    }).formatToParts(new Date());

    var hour = 0;
    var minute = 0;
    var weekday = 'Sun';

    parts.forEach(function (p) {
      if (p.type === 'hour') hour = parseInt(p.value, 10);
      if (p.type === 'minute') minute = parseInt(p.value, 10);
      if (p.type === 'weekday') weekday = p.value;
    });

    var dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return { day: dayMap[weekday] ?? 0, minutes: hour * 60 + minute };
  }

  function isStoreOpen(schedule, tz) {
    if (!Array.isArray(schedule) || !schedule.length) return null;

    var now = getNowInTimezone(tz);
    var today = schedule.find(function (entry) {
      return Number(entry.weekday) === now.day;
    });

    if (!today || today.closed) return false;

    var open = parseTime(today.open);
    var close = parseTime(today.close);
    if (open === null || close === null) return false;

    return now.minutes >= open && now.minutes < close;
  }

  function init() {
    document.querySelectorAll('[data-store-open-status]').forEach(function (el) {
      var hoursId = el.getAttribute('data-hours-id');
      var script = hoursId ? document.getElementById(hoursId) : null;
      var schedule = [];

      if (script && script.textContent) {
        try {
          schedule = JSON.parse(script.textContent);
        } catch (e) {
          schedule = [];
        }
      }

      var tz = el.getAttribute('data-timezone') || 'America/Sao_Paulo';
      var open = isStoreOpen(schedule, tz);

      if (open === null) {
        el.hidden = true;
        return;
      }

      var labelOpen = el.getAttribute('data-label-open') || 'Aberto agora';
      var labelClosed = el.getAttribute('data-label-closed') || 'Fechado agora';
      var textEl = el.querySelector('[data-status-text]');

      el.hidden = false;
      el.classList.remove('location-status--open', 'location-status--closed');
      el.classList.add(open ? 'location-status--open' : 'location-status--closed');
      el.setAttribute('aria-label', open ? labelOpen : labelClosed);

      if (textEl) {
        textEl.textContent = open ? labelOpen : labelClosed;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
